import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const currencyK = {
  dkk: "currency.dkk",
  eur: "currency.eur",
  dem: "currency.dem",
  nok: "currency.nok",
  usd: "currency.usd",
};

export const useCurrencyT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      dkk: t(currencyK.dkk),
      eur: t(currencyK.eur),
      dem: t(currencyK.dem),
      nok: t(currencyK.nok),
      usd: t(currencyK.usd),
    }),
    [i18n.language]
  );
};